import DateRangeFilter from "../../../filterDropdown/DateRangeFilter";

type SalesPeriodDateRangeProps = {
  period: 1 | 2;
  startDate: Date | string | null;
  endDate: Date | string | null;
  startDateName?: string;
  endDateName?: string;
  maxDate: Date;
  onChange: (name: string, value: unknown) => void;
  resetFilter: () => void;
  className?: string;
};

export default function SalesPeriodDateRange({
  period,
  className = "",
  ...dateRangeProps
}: SalesPeriodDateRangeProps) {
  return (
    <fieldset className={className}>
      <legend className="mb-1 text-sm font-semibold text-brand">
        Sales period {period}
      </legend>
      <DateRangeFilter hideTitle={true} {...dateRangeProps} />
    </fieldset>
  );
}
